import {frameworkSound} from "../../../core/components/sounds/configuration/soundconfiguration"
import {soundAssetConfig as soundAssetConfig} from "../../../data/sounds";


frameworkSound.data = {
    sfx: {
        "bigWinLoop": {id: "bigWinLoop", src: soundAssetConfig["bigWinLoop"], loop: false, vol: 0.7},
        "reelSpinSound": {id: "reelSpinSound", src: soundAssetConfig["reelSpinSound"], loop: false, vol: 0.7},
        "superWinLoop": {id: "superWinLoop", src: soundAssetConfig["superWinLoop"], loop: false, vol: 0.7},
        "megaWinLoop": {id: "megaWinLoop", src: soundAssetConfig["megaWinLoop"], loop: false, vol: 0.7},
        "reelStoppingSound": { id: "reelStoppingSound", src: soundAssetConfig["reelStoppingSound"], loop: false, vol: 0.4 },
        "tickupSound": { id: "tickupSound", src: soundAssetConfig["tickupSound"], loop: false, vol: 0.7 },
        "coinShowerSound": { id: "coinShowerSound", src: soundAssetConfig["coinShowerSound"], loop: false, vol: 0.7 },
        "winLevel_1": { id: "winLevel_1", src: soundAssetConfig["winLevel_1"], loop: false, vol: 0.7 },
        "winLevel_2": { id: "winLevel_2", src: soundAssetConfig["winLevel_2"], loop: false, vol: 0.7 },
        "winLevel_3": { id: "winLevel_3", src: soundAssetConfig["winLevel_3"], loop: false, vol: 0.7 },
        "scatterLandingSound": { id: "scatterLandingSound", src: soundAssetConfig["scatterLandingSound"], loop: false, vol: 0.7 },
        "symbol_blast": { id: "symbol_blast", src: soundAssetConfig["symbol_blast"], loop: false, vol: 0.7 },
        "energyToSymbol": { id: "energyToSymbol", src: soundAssetConfig["energyToSymbol"], loop: false, vol: 0.7 },
        "symbolToWilds": { id: "symbolToWilds", src: soundAssetConfig["symbolToWilds"], loop: false, vol: 0.7 },
        "giantwild1": { id: "giantwild1", src: soundAssetConfig["giantwild1"], loop: false, vol: 0.7 },
        "giantwild2": { id: "giantwild2", src: soundAssetConfig["giantwild2"], loop: false, vol: 0.7 },
        "popOutSound": { id: "popOutSound", src: soundAssetConfig["popOutSound"], loop: false, vol: 0.7 },
        "symbol_1": { id: "symbol_1", src: soundAssetConfig["symbol_1"], loop: false, vol: 0.7 },
        "symbol_2": { id: "symbol_2", src: soundAssetConfig["symbol_2"], loop: false, vol: 0.7 },
        "symbol_6": { id: "symbol_6", src: soundAssetConfig["symbol_6"], loop: false, vol: 0.7 },
        "symbol_7": { id: "symbol_7", src: soundAssetConfig["symbol_7"], loop: false, vol: 0.7 },
        "symbol_8": { id: "symbol_8", src: soundAssetConfig["symbol_8"], loop: false, vol: 0.7 },
        "symbol_9": { id: "symbol_9", src: soundAssetConfig["symbol_9"], loop: false, vol: 0.7 },
        "reelAppear": { id: "reelAppear", src: soundAssetConfig["reelAppear"], loop: false, vol: 0.7 },
        "reelDisappear": { id: "reelDisappear", src: soundAssetConfig["reelDisappear"], loop: false, vol: 0.7 },
        "multiplierFG": { id: "multiplierFG", src: soundAssetConfig["multiplierFG"], loop: false, vol: 0.7 },
        "introLoop": {id: "introLoop", src: soundAssetConfig["introLoop"], loop: false, vol: 0.7},
        "spinButtonSound": {id: "spinButtonSound", src: soundAssetConfig["spinButtonSound"], loop: false, vol: 0.7},    
        "tumbleSound": { id: "tumbleSound", src: soundAssetConfig["tumbleSound"], loop: false, vol: 0.7 },    
        "genericButtonSound": {
            id: "genericButtonSound",
            src: soundAssetConfig["genericButtonSound"],
            loop: false,
            vol: 0.7
        },
        "continueButtonSound": {
            id: "continueButtonSound",
            src: soundAssetConfig["continueButtonSound"],
            loop: false,
            vol: 0.7
        },
        "fgOutroSound": {id: "fgOutroSound", src: soundAssetConfig["fgOutroSound"], loop: false, vol: 0.7},
    },
    bg: {
        "bgloop": {id: "bgloop", src: soundAssetConfig["baseGameLoop"], loop: true, vol: 0.15},
        "fgloop": {id: "fgloop", src: soundAssetConfig["freeGameLoop"], loop: true, vol: 0.5},
    }
}
